<template lang="html">
  <bootstrap-modal ref="reportModal" :need-header="true" :need-footer="true" :closed="closedModal" size="large">
    <div slot="title">Relatório</div><!-- end title -->

    <div slot="body" v-if="options">
      <div class="row">
          <div class="col-md-10"></div>
          <div class="col-md-2">
              <a href="#" @click.prevent="showConfig = !showConfig" class="btn btn-warning btn-xs">
                  <icon name="cog"></icon> <strong>Opções</strong>
              </a>
          </div>
      </div>

      <div class="row exibir-configuracoes">
        <div class="col-md-12" v-show="!showConfig">
          <h4 class="text-center">Selecione as seguradoras para gerar o relatório</h4>
          <div class="panel panel-default" v-for="(coverage, index) in options.coverages" :key="coverage.number">
            <div class="panel-heading">
              <div class="row">
                <div class="col-sm-6">
                  <label class="no-margin">
                    Cobertura {{ coverage.number }} <span class="label label-success" v-if="index === 0">ÚLTIMA CALCULADA</span>
                  </label>
                </div>
                <div class="col-sm-3">
                  <label class="custom-checkbox no-margin">
                    <input type="checkbox" checked="index === 0" class="checkall" @change="checkInsurers($event, coverage.prices)">TODOS
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="col-sm-3">
                  <label class="custom-checkbox no-margin">
                      <input id="chbCheckProdutosAdicionais" type="checkbox" checked="index === 0" class="checkall" @change="checkInsurersWithAdditionalProduct($event, coverage.prices)">PRODUTOS ADICIONAIS
                      <span class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-3 min-card-height" v-for="price in coverage.prices" :key="price.priceId">
                  <div class="padding-price">
                    <div class=bording-price>
                      <div class="row">
                        <label class="custom-checkbox">
                          {{ price.insurer }}
                          <input type="checkbox" :class="{'checkmark':true, 'additional-products-checkmark':(price.product_additional)}" name="seguradoras[]" :value="price.priceId" :checked="price.check" @change="price.check = !price.check">
                          <span class="checkmark"></span>
                        </label>
                      </div>
                      <div v-if="price.product_additional" class="produto-adicional"><label class="custom-checkbox"> PRODUTO ADICIONAL </label></div>
                      <div><i class="fa fa-money"></i> {{ price.value }}</div>
                      <div><i class="fa fa-percent"></i> {{ price.commission }}</div>
                      <div><strong>{{ price.product }}</strong></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div><!-- end col -->
      </div>

      <div class="row exibir-configuracoes">
          <div class="col-md-12" v-show="showConfig">
              <div class="row">
                  <div class="col-xs-12 col-md-8 col-md-offset-2">
                      <h4>Selecione a quantidade de parcelas para exibir</h4>
                      <select class="form-control" name="parcela" v-model="options.parcela">
                          <option v-for="parcela in parcelas" :value="parcela" :key="parcela">{{ parcela + ' ' + (parcela == 1 ? 'vez' : 'vezes') }}</option>
                      </select>
                      <br>
                  </div>
                  <div class="col-xs-12 col-md-8 col-md-offset-2" v-if="(options.residential) == false || options.residential === undefined">
                      <h4>Selecione o tipo do relatório</h4>
                      <select class="form-control" name="relatorio" v-model="options.relatorio">
                          <option v-for="(value, key) in relatorios" :value="key" :key="key">{{ value }}</option>
                      </select>
                      <br>
                  </div>
                  <div class="col-xs-12 col-md-12" v-if="!options.hasLogo && !token">
                      <div class="text-danger">
                          <p style="text-align: center !important">
                              Sua corretora não possui logo cadastrada:
                              <a :href="options.corretora_edit" target="_blank">Adicionar</a>
                          </p>
                      </div>
                  </div>
                  <div class="col-xs-12 col-md-12" v-if="!token">
                      <p class="bg-warning message-attention">
                          ATENÇÃO: Nobre Corretor(a), o relatório em questão ainda está em desenvolvimento e pode conter informações divergentes em relação as seguradoras. Caso verifique que algo pode ser melhorado, favor entrar em contato conosco e informar. Agradecemos a sua ajuda e compreensão!
                      </p>
                  </div>
              </div>
          </div><!-- end col -->
      </div><!-- end row -->

    </div><!-- end body -->

    <div slot="footer">
        <div class="row">
            <div class="col-md-6 text-rigth" v-if="errors & !token" :class="{ 'has-error': errors.has('other_email[]') }">
                <input type="text" class="form-control valid-email" name="other_email[]" placeholder="E-mail" :value="options.email" v-validate="{ rules: { email: true } }" data-vv-as="E-mail" :disabled="isDetailedReport">
                <div class="error-message" v-if="errors.has('other_email[]')">{{ errors.first('other_email[]') }}</div>
            </div>
            <div class="col-md-6 text-left">
                <button type="button" class="btn btn-warning" @click.prevent="sendReportToEmail" :disabled="isDetailedReport" v-if="!token">
                  Enviar por E-mail
                </button>
                <button type="button" class="btn btn-info" @click.prevent="downloadReport($event, 'pdf')">
                  Gerar PDF
                </button>
                <button type="button" class="btn btn-info" @click.prevent="downloadReport($event, 'xls')" :disabled="isDetailedReport">
                  Gerar XLS
                </button>
            </div>
        </div>
    </div><!-- end footer -->
  </bootstrap-modal>
</template>

<script>
  import BootstrapModal from "vue2-bootstrap-modal"
  import jQuery from "jquery"
  // import { Validator } from "vee-validate"

  export default {
    components: {
      BootstrapModal,
    },
    props: ["printModalResult", "token"],
    data() {
      return {
        openModal: false,
        showConfig: false,
        parcelas: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        relatorios: {
          s: "Simples",
          c: "Completo",
          d: "Detalhado",
        },
      };
    },
    watch: {
      options(value) {
        this.openModal = value.openModal || false;
      },
      openModal(value) {
        if (value) this.$refs.reportModal.open();
      },
    },
    computed: {
      token() {
        return this.$root.$options.config.token;
      },
      options() {
        return this.printModalResult;
      },
      isDetailedReport() {
        return this.options.relatorio === "d";
      },
      inputEmail() {
        return this.$el.querySelector('input[name="other_email[]"]');
      },
    },
    methods: {
      closedModal() {
        this.openModal = false;
      },
      sendReportToEmail() {
        this.$store.dispatch(
          "exibeMensagemCarregamento",
          "Enviando relatório por e-mail..."
        );

        this.$http
          .get(
            this.$root.$options.config.environment.applicationUrl +
              "/relatorio_cotacao",
            this.parseParams("email")
          )
          .then((response) => {
            this.$store.dispatch(
              "exibeMensagemCarregamento",
              response.body.message
            );
            this.$store.dispatch("closeLoading", 3000);
          });
      },
      downloadReport(e, typeOutput) {
        let params = this.parseParams(typeOutput).params;
        if (this.token) params.token = this.token;

        var ifr = document.createElement("iframe"); // Tratando com iframes porque no chrome começou a dar problema com _blank
        ifr.style.display = "none";
        document.body.appendChild(ifr);
        var urlIframe =
          this.$root.$options.config.environment.applicationUrl +
          "/impressoes/residencial/relatorio?" +
          jQuery.param(params);
        ifr.src = urlIframe;
        ifr.onload = function(e) {
          document.body.removeChild(ifr);
          ifr = null;
        };
      },
      parseParams(typeOutput) {
        let formData = {
          params: {
            seguradoras: [],
            cotacao_id: this.options.quotationId,
            parcela: this.$el.querySelector('select[name="parcela"]').value,
            token: this.token,
            format: typeOutput,
          },
        };

        this.$el
          .querySelectorAll('input[name="seguradoras[]"]:checked')
          .forEach((item) => {
            formData.params.seguradoras.push(item.value);
          });

        return formData;
      },
      checkInsurers(e, prices) {
        const checked = jQuery(e.target).is(":checked");

        jQuery(e.target)
          .parents("div.panel-default")
          .find("input.checkmark")
          .each((index, obj) => jQuery(obj).prop("checked", checked));
          
        prices.forEach((item) => {
          item.check = checked;
        });

        jQuery("#chbCheckProdutosAdicionais").prop("checked", checked)
      },
      checkInsurersWithAdditionalProduct(e, prices) {
        const checked = jQuery(e.target).is(":checked");

        jQuery(e.target)
          .parents("div.panel-default")
          .find("input.additional-products-checkmark")
          .each((index, obj) => jQuery(obj).prop("checked", checked));

        prices.forEach(item => {
          if(item.product_additional)
            item.check = checked;
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
.message-attention {
  padding: 20px;
}

.exibir-configuracoes .container {
  margin-left: 20px;
  margin-right: 20px;
}

.padding-price {
  padding: 5px;
}

.bording-price {
  border: 1px solid #eee;
  padding: 10px;
}

/* The container */
.custom-checkbox {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default checkbox */
.custom-checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  top: -10px;
  left: 5px;
  height: 20px;
  width: 20px;
  background-color: #eee;
}

/* On mouse-over, add a grey background color */
.custom-checkbox:hover input ~ .checkmark {
  background-color: #ccc;
}

/* When the checkbox is checked, add a blue background */
.custom-checkbox input:checked ~ .checkmark {
  background-color: #e44c34;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.custom-checkbox input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.custom-checkbox .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.check-title .checkmark {
  position: absolute;
  top: 7px;
  left: 95%;
}
</style>



// WEBPACK FOOTER //
// PartialModalPrint.vue?583c50a1